// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selfProgressBar__wrapper","licence-count":"selfProgressBar__licence-count","real-count":"selfProgressBar__real-count","not-licence":"selfProgressBar__not-licence"};